<template>
    <div class="">
        <b-row>
            <b-col>
                <div class="widget_heading mb-3">
                    <span class="float-right text-danger">
                        Los campos con (*) son obligatorios
                    </span>
                </div>
            </b-col>
            <div class="w-100"></div>
            <b-col>
                <div class="form-group">
                    <label class="form-label">
                        Nombre
                        <span class="text-danger">*</span>
                    </label>
                    <input
                        v-model.trim="$v.nombre.$model"
                        :class="{ 'is-invalid': $v.nombre.$error }"
                        type="text"
                        class="form-control"
                    />
                    <div class="invalid-feedback">
                        <span v-if="!$v.nombre.$required"
                            >Este campo es requerido</span
                        >
                    </div>
                </div>
            </b-col>
            <b-col>
                <div class="form-group">
                    <label class="form-label">
                        Apellido
                        <span class="text-danger">*</span>
                    </label>
                    <input
                        v-model.trim="$v.apellido.$model"
                        :class="{ 'is-invalid': $v.apellido.$error }"
                        type="text"
                        class="form-control"
                    />
                    <div class="invalid-feedback">
                        <span v-if="!$v.apellido.$required"
                            >Este campo es requerido</span
                        >
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <div class="form-group">
                    <label class="form-label">
                        Correo electrónico
                        <span class="text-danger">*</span>
                    </label>
                    <input
                        v-model.trim="$v.email.$model"
                        :class="{ 'is-invalid': $v.email.$error }"
                        type="email"
                        class="form-control"
                    />
                    <div class="invalid-feedback">
                        <span v-if="!$v.email.$required"
                            >Este campo es requerido</span
                        >
                        <br />
                        <span v-if="!$v.email.$email"
                            >Formato de correo electrónico inválido</span
                        >
                    </div>
                </div>
            </b-col>
            <b-col>
                <div class="form-group">
                    <label class="form-label">
                        Celular
                        <span class="text-danger">*</span>
                    </label>
                    <input
                        v-model.number.lazy="$v.celular.$model"
                        :class="{ 'is-invalid': $v.celular.$error }"
                        type="text"
                        class="form-control"
                        maxlength="10"
                    />
                    <div class="invalid-feedback">
                        <span v-if="!$v.celular.$required"
                            >Este campo es requerido</span
                        >
                        <br />
                        <span v-if="!$v.celular.$numeric"
                            >Formato de teléfono inválido</span
                        >
                    </div>
                </div>
            </b-col>
        </b-row>
        <div class="form-group">
            <label>
                <i class="fa fa-check-square" aria-hidden="true"></i>
                Al solicitar tu test drive estás aceptando nuestra
                <a
                    href="https://redautos.com/politica_tratamiento_datos_personales"
                    target="_blank"
                >
                    Política de privacidad de datos personales
                </a>
            </label>
        </div>
        <div class="form-group">
            <button
                :disabled="onLoadForm"
                class="btn btn-block"
                type="submit"
                @click="onReservaForm"
            >
                Agendar Cita
                <clip-loader
                    :class="{ 'd-none': !onLoadForm }"
                    style="display: inline;margin-right: 10px;"
                    color="#fff"
                    size="15px"
                ></clip-loader>
            </button>
        </div>
    </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { required, email, numeric } from "vuelidate/lib/validators";
export default {
    data() {
        return {
            onLoadForm: false
        };
    },
    computed: {
        ...mapFields("testDrive", [
            "nombre",
            "apellido",
            "email",
            "celular",
            "asistente_step",
            "id_consignacion"
        ])
    },
    validations: {
        nombre: {
            required
        },
        apellido: {
            required
        },
        email: {
            required,
            email
        },
        celular: {
            required,
            numeric
        }
    },
    methods: {
        onReservaForm() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return (this.submitStatus = "False");
            } else {
                this.onLoadForm = true;
                var data = {
                    id_reporte: this.id_consignacion,
                    nombre: this.nombre,
                    apellido: this.apellido,
                    celular: this.celular,
                    email: this.email
                };
                axios.post("/create_test_drive", data).then(response => {
                    var responseData = response.data;
                    if (responseData.status === "success") {
                        this.onLoadForm = false;
                        var queryString = window.location.search;
                        var urlParams = new URLSearchParams(queryString);
                        var ficha_tecnica = urlParams.get("ficha_tecnica");
                        window.location.href = '/test_drive_reservado?ficha_tecnica=' + ficha_tecnica;
                        // this.asistente_step = "response";
                        // window.history.replaceState(null,null,"?step=2&ficha_tecnica="+ficha_tecnica);
                    }
                });
            }
        }
    }
};
</script>

<style lang="scss">
h5.text-red {
    color: #fa2837;
}
</style>
